/**
 * React
 */
import React, { useCallback, useState } from 'react';

/**
 * Library
 */
import clsx from 'clsx';
import koLocale from 'date-fns/locale/ko';

/**
 * MUI
 */
import { MuiPickersUtilsProvider, DatePicker, KeyboardDatePicker } from '@material-ui/pickers';
import { Grid, Typography, makeStyles, Theme, Hidden } from '@material-ui/core';

/**
 * Component
 */
import { FromToDateProps } from 'components/Date/type';

/**
 * Utils
 */
import KoLocalizedUtils from 'commons/utils/DateUtils';

const useStyles = makeStyles((theme: Theme) => ({
  date: {
    flexBasis: '48%',
    '& > div': {
      borderRadius: 0,
      '&.Mui-focused': {
        '& > fieldset': {
          border: '1px solid #b4b4b4 !important',
        },
      },
      '& > .MuiOutlinedInput-input': {
        padding: '0 10px',
        height: '34px',
      },
    },
    margin: 0,
  },
}));


function FromToDate({ from, to, onChangeFrom, onChangeTo }: FromToDateProps) {
  const classes = useStyles();
  const [invalidFrom, setInvalidFrom] = useState<boolean>(false);
  const [invalidTo, setInvalidTo] = useState<boolean>(false);

  const onInvalidateFrom = useCallback((error, value) => {
    if (error == null || error == undefined) {
      setInvalidFrom(true);
    } else {
      setInvalidFrom(false);
    }
  }, []);

  const onInvalidateTo = useCallback((error, value) => {
    if (error == null || error == undefined) {
      setInvalidTo(true);
    } else {
      setInvalidTo(false);
    }
  }, []);

  return (
    <MuiPickersUtilsProvider utils={KoLocalizedUtils} locale={koLocale}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Hidden mdDown>
          <KeyboardDatePicker
            className={clsx(classes.date)}
            variant="inline"
            inputVariant="outlined"
            format="yyyy-MM-dd"
            margin="normal"
            value={from}
            invalidDateMessage={null}
            error={invalidFrom}
            onError={onInvalidateFrom}
            onChange={onChangeFrom}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputAdornmentProps={{ position: 'start' }}
            autoOk
            clearable
            type="search"
          />
          <Typography>-</Typography>
          <KeyboardDatePicker
            className={classes.date}
            variant="inline"
            inputVariant="outlined"
            format="yyyy-MM-dd"
            margin="normal"
            value={to}
            invalidDateMessage={null}
            error={invalidTo}
            onChange={onChangeTo}
            onError={onInvalidateTo}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputAdornmentProps={{ position: 'start' }}
            autoOk
            clearable
            type="search"
          />
        </Hidden>
        <Hidden lgUp>
          <DatePicker
            className={clsx(classes.date)}
            variant="dialog"
            inputVariant="outlined"
            format="yyyy-MM-dd"
            margin="normal"
            value={from}
            invalidDateMessage={null}
            error={invalidFrom}
            onError={onInvalidateFrom}
            onChange={onChangeFrom}
            autoOk
            clearable
            cancelLabel="취소"
            clearLabel="초기화"
            okLabel="선택"
          />
          <Typography>-</Typography>
          <DatePicker
            className={clsx(classes.date)}
            variant="dialog"
            inputVariant="outlined"
            format="yyyy-MM-dd"
            margin="normal"
            value={to}
            invalidDateMessage={null}
            error={invalidTo}
            onError={onInvalidateTo}
            onChange={onChangeTo}
            autoOk
            clearable
            cancelLabel="취소"
            clearLabel="초기화"
            okLabel="선택"
          />
        </Hidden>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}

export default FromToDate;
